import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useWeb3 } from '../context/Web3Context';
import '../styles/bottomnav.css';

function IconDashboard() {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="12" width="7" height="9" rx="1"/><rect x="3" y="16" width="7" height="5" rx="1"/></svg>;
}
function IconMatrix() {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="5" r="3"/><circle cx="5" cy="19" r="3"/><circle cx="19" cy="19" r="3"/><path d="M12 8v3M7.5 17.2L10.5 11M16.5 17.2L13.5 11"/></svg>;
}
function IconPools() {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>;
}
function IconProfile() {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
}
function IconAdmin() {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
}

const iconMap = {
  '/': IconDashboard,
  '/matrix': IconMatrix,
  '/pools': IconPools,
  '/profile': IconProfile,
  '/admin': IconAdmin,
};

const userTabs = [
  { path: '/', label: 'Dashboard' },
  { path: '/matrix', label: 'Matrix' },
  { path: '/pools', label: 'Rewards' },
  { path: '/profile', label: 'Profile' },
];

const adminTab = { path: '/admin', label: 'Admin' };

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAdmin } = useWeb3();

  const tabs = isAdmin ? [...userTabs, adminTab] : userTabs;

  return (
    <div className="bottom-nav">
      {tabs.map(tab => {
        const IconComp = iconMap[tab.path];
        return (
          <button
            key={tab.path}
            className={`bottom-nav-item ${location.pathname === tab.path ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <span className="bottom-nav-icon"><IconComp /></span>
            <span className="bottom-nav-label">{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
